import api from './index';

export default {
  sendInvitation(data) {
    return api({
      method: 'post',
      url: '/api/internal/invitations/send_email',
      data,
    });
  },
};
